import React, { useRef } from "react";
import ProductCard from "./ProductCard";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";

function ProductSlide({ data, title, tagline }) {
  const sliderRef = useRef(null);

  const scrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (sliderRef.current) {
      const maxScroll =
        sliderRef.current.scrollWidth - sliderRef.current.clientWidth;
      if (sliderRef.current.scrollLeft >= maxScroll - 10) {
        // jump back to start
        sliderRef.current.scrollTo({ left: 0, behavior: "smooth" });
      } else {
        sliderRef.current.scrollBy({ left: 300, behavior: "smooth" });
      }
    }
  };

  return (
    <div className="bg-white pt-5 pb-20 overflow-x-hidden relative hide-scrollbar">
      <div className="container mx-auto px-4 flex flex-col items-center gap-4">
        {/* Title Section */}
        <div className="md:w-[500px] w-full text-center flex flex-col gap-2">
          <h1 className="font-syne text-2xl md:text-4xl font-bold text-gradient-black">
            {title}
          </h1>
          <p className="font-outfit text-black text-[16px] font-light">
            {tagline}
          </p>
        </div>

        {/* Slider Section */}
        <div className="w-full relative hide-scrollbar">
          {/* Scrollable container */}
          <div
            ref={sliderRef}
            className="flex gap-4 overflow-x-auto scroll-smooth px-2 hide-scrollbar"
            style={{
              scrollSnapType: "x mandatory",
              WebkitOverflowScrolling: "touch",
            }}
          >
            {data?.map((item, index) => (
              <div className="flex-shrink-0 ">
                <ProductCard products={item} />
              </div>
            ))}
          </div>

          {/* Left Button */}
          <button
            onClick={scrollLeft}
            className="absolute top-1/2 left-0 sm:left-2 md:left-[-10px] lg:left-[-40px] w-10 h-10 sm:w-12 sm:h-12 bg-white rounded-full flex items-center justify-center transform -translate-y-1/2 z-20 shadow-lg hover:scale-110 transition-all"
          >
            <FaAngleLeft className="text-black text-xl sm:text-2xl" />
          </button>

          {/* Right Button */}
          <button
            onClick={scrollRight}
            className="absolute top-1/2 right-0 sm:right-2 md:right-[-10px] lg:right-[-60px] w-10 h-10 sm:w-12 sm:h-12 bg-white rounded-full flex items-center justify-center transform -translate-y-1/2 z-20 shadow-lg hover:scale-110 transition-all"
          >
            <FaAngleRight className="text-black text-xl sm:text-2xl" />
          </button>
        </div>
      </div>
    </div>
  );
}

export default ProductSlide;

// import React, { useRef } from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, Navigation } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/navigation";
// import ProductCard from "./ProductCard";
// import { FaAngleLeft, FaAngleRight } from "react-icons/fa";

// function ProductSlide({ data, title, tagline }) {
//   const slidesRef = useRef([]);
//   const swiperRef = useRef(null);
//   const sliderRef = useRef(null);

//   // Slick settings
//   const settings = {
//     infinite: true,
//     speed: 500,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 2500,
//     responsive: [
//       { breakpoint: 1280, settings: { slidesToShow: 4, slidesToScroll: 1 } },
//       { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1 } },
//       { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1 } },
//       { breakpoint: 640, settings: { slidesToShow: 2, slidesToScroll: 1 } },
//       { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
//       { breakpoint: 0, settings: { slidesToShow: 1, slidesToScroll: 1 } },
//     ],
//   };
//   return (
//     <div className="bg-black pt-5 pb-5 overflow-x-hidden">
//       <div className="container mx-auto px-4 flex flex-col items-center gap-4">
//         {/* Title Section */}
//         <div className="md:w-[500px] w-full text-center flex flex-col gap-2">
//           <h1 className="font-syne text-2xl md:text-5xl font-bold text-gradient">
//             {title}
//           </h1>
//           <p className="font-outfit text-white text-[16px] font-light">
//             {tagline}
//           </p>
//         </div>

//         {/* Slider Section */}
//         <div className="w-full relative mt-4">
//           <Swiper
//             // modules={[Autoplay]}
//             onSwiper={(swiper) => (swiperRef.current = swiper)}
//             spaceBetween={15} // distance between slides
//             slidesPerView={4} // default for mobile
//             breakpoints={{
//               480: { slidesPerView: 1, spaceBetween: 10 },
//               640: { slidesPerView: 2, spaceBetween: 15 },
//               768: { slidesPerView: 2, spaceBetween: 20 },
//               1024: { slidesPerView: 3, spaceBetween: 25 },
//               1280: { slidesPerView: 4, spaceBetween: 30 },
//             }}
//           >
//             {data?.map((item, index) => (
//               <SwiperSlide key={index} className="!w-auto">
//                 <div ref={(el) => (slidesRef.current[index] = el)}>
//                   <ProductCard products={item} />
//                 </div>
//               </SwiperSlide>
//             ))}
//           </Swiper>

//           <button
//             onClick={() => swiperRef.current?.slidePrev()}
//             className="absolute top-1/2 left-0 sm:left-2 md:left-[-10px] lg:left-[-40px] w-10 h-10 sm:w-12 sm:h-12 bg-white rounded-full flex items-center justify-center transform -translate-y-1/2 z-20 shadow-lg hover:scale-110 transition-all"
//           >
//             <FaAngleLeft className="text-black text-xl sm:text-2xl" />
//           </button>

//           <button
//             onClick={() => swiperRef.current?.slideNext()}
//             className="absolute top-1/2 right-0 sm:right-2 md:right-[-10px] lg:right-[-60px] w-10 h-10 sm:w-12 sm:h-12 bg-white rounded-full flex items-center justify-center transform -translate-y-1/2 z-20 shadow-lg hover:scale-110 transition-all"
//           >
//             <FaAngleRight className="text-black text-xl sm:text-2xl" />
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ProductSlide;
